import Input from 'portaltransparencia-common/components/EloInput.react.js';
import { List, Map } from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row } from 'react-bootstrap';

import FilterButtons from '../components/FilterButtons.react.js';
import FormFilterProgramatica from '../programatica/FormFilterProgramatica.react';
import { TipoEmendaParlamentar } from './TipoEmendaParlamentar';
import { NumericFormat } from 'react-number-format';

const LIMIT_VALUE = 9999999999999999;

const FormFilter = ({
  filtros,
  onConsulta,
  onReset,
  onChange,
  tiposTransferencias,
  tiposOrigens,
  tipo,
  isIntegradoOxy
}) => {
  const f = filtros || Map({});
  const tipos = tiposTransferencias || List();
  const origens = tiposOrigens || List();

  const isEmendaMunicipal = tipo === TipoEmendaParlamentar.MUNICIPAL;

  return (
    <form onSubmit={onConsulta}>
      <Row>
        <Col xs={6} sm={4} md={3}>
          <Input
            id="numero"
            name="numero"
            placeholder="Informe o Número"
            label="Número"
            type="number"
            min={0}
            onChange={onChange}
            value={f.get('numero', '')}
          />
        </Col>
        <Col xs={6} sm={4} md={3}>
          <Input
            id="planoAcao"
            name="planoAcao"
            placeholder="Informe o Plano de Ação"
            label="Plano de Ação"
            type="text"
            onChange={onChange}
            value={f.get('planoAcao', '')}
          />
        </Col>
        <Col xs={12} sm={4} md={3}>
          <Input
            id="tipoTransferencia"
            name="tipoTransferencia"
            label="Forma de Repasse"
            type="select"
            onChange={onChange}
            value={f.get('tipoTransferencia', '')}
          >
            <option value="">Todos</option>

            {tipos.map(item => (
              <option key={item.get('codigo')} value={item.get('codigo')}>
                {item.get('descricao')}
              </option>
            ))}
          </Input>
        </Col>
        <Col xs={12} sm={4} md={3}>
          <Input
            id="origemEmenda"
            name="origemEmenda"
            label="Tipo de Transferência"
            type="select"
            onChange={onChange}
            value={f.get('origemEmenda', '')}
          >
            <option value="">Todos</option>

            {origens.map(item => (
              <option key={item.get('codigo')} value={item.get('codigo')}>
                {item.get('descricao')}
              </option>
            ))}
          </Input>
        </Col>
      </Row>

      {isEmendaMunicipal && (
        <Row>
          <Col xs={12} sm={4} md={3}>
            <Input
              id="numeroLeiAto"
              name="numeroLeiAto"
              placeholder="Informe o Nº Lei/Ato"
              label="Nº Lei/Ato"
              type="number"
              min={0}
              onChange={onChange}
              value={f.get('numeroLeiAto', '')}
            />
          </Col>
          <Col xs={12} sm={4} md={9}>
            <Input
              id="nomeAutor"
              name="nomeAutor"
              placeholder="Informe o nome do Vereador"
              label="Nome do Vereador"
              type="text"
              onChange={onChange}
              value={f.get('nomeAutor', '')}
            />
          </Col>
        </Row>
      )}

      {!isEmendaMunicipal && (
        <>
          <Row>
            <Col xs={12} sm={4} md={3}>
              <Input
                id="numeroLeiAto"
                name="numeroLeiAto"
                placeholder="Informe o Nº Lei/Ato"
                label="Nº Lei/Ato"
                type="number"
                min={0}
                onChange={onChange}
                value={f.get('numeroLeiAto', '')}
              />
            </Col>
            <Col xs={12} sm={4} md={3}>
              <Input
                id="nomeAutor"
                name="nomeAutor"
                placeholder="Informe o nome do Autor"
                label="Autor da Emenda"
                type="text"
                onChange={onChange}
                value={f.get('nomeAutor', '')}
              />
            </Col>
            <Col xs={12} sm={4} md={6}>
              <Input
                id="partido"
                name="partido"
                placeholder="Informe o nome do partido"
                label="Partido"
                type="text"
                onChange={onChange}
                value={f.get('partido', '')}
              />
            </Col>
          </Row>
          <Row>
            {!isIntegradoOxy && (
              <Col xs={12} sm={4} md={6}>
                <Input
                  id="localidadeBeneficiada"
                  name="localidadeBeneficiada"
                  placeholder="Informe a localidade beneficiada"
                  label="Localidade Beneficiada"
                  type="text"
                  onChange={onChange}
                  value={f.get('localidadeBeneficiada', '')}
                />
              </Col>
            )}
            <Col xs={12} sm={4} md={3}>
              <NumericFormat
                id="valorPrevisto"
                name="valorPrevisto"
                label="Valor Previsto"
                placeholder="R$ 0,00"
                customInput={Input}
                type="text"
                prefix="R$ "
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={2}
                fixedDecimalScale
                allowNegative={false}
                isAllowed={({ floatValue }) =>
                  floatValue === undefined || floatValue <= LIMIT_VALUE
                }
                onValueChange={({ floatValue }) =>
                  onChange({
                    target: { name: 'valorPrevisto', value: floatValue ?? '' }
                  })
                }
                value={f.get('valorPrevisto', '')}
              />
            </Col>
            <Col xs={12} sm={4} md={3}>
              <NumericFormat
                id="valorRepassado"
                name="valorRepassado"
                label="Valor Repassado"
                placeholder="R$ 0,00"
                customInput={Input}
                type="text"
                prefix="R$ "
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={2}
                fixedDecimalScale
                allowNegative={false}
                isAllowed={({ floatValue }) =>
                  floatValue === undefined || floatValue <= LIMIT_VALUE
                }
                onValueChange={({ floatValue }) =>
                  onChange({
                    target: { name: 'valorRepassado', value: floatValue ?? '' }
                  })
                }
                value={f.get('valorRepassado', '')}
              />
            </Col>
          </Row>
        </>
      )}

      <Row>
        <Col xs={12} sm={12} md={12}>
          <Input
            id="objetivoFinalidade"
            name="objetivoFinalidade"
            placeholder="Informe o Objeto/Finalidade"
            label="Objeto/Finalidade"
            type="text"
            onChange={onChange}
            value={f.get('objetivoFinalidade', '')}
          />
        </Col>
      </Row>

      <FormFilterProgramatica filtros={filtros} onChange={onChange} />

      <FilterButtons
        idBtnReset="btnResetFilter"
        onConsulta={onConsulta}
        onReset={onReset}
      />
    </form>
  );
};

FormFilter.propTypes = {
  filtros: PropTypes.instanceOf(Map),
  onConsulta: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  tiposTransferencias: PropTypes.instanceOf(List),
  tiposOrigens: PropTypes.instanceOf(List),
  tipo: PropTypes.oneOf(Object.values(TipoEmendaParlamentar)).isRequired,
  isIntegradoOxy: PropTypes.bool
};

export default FormFilter;
